// Généré par scripts/generate-permissions.mjs — voir l'en-tête du script.
// Catalogue : 269 permissions.
enum Permissions {
  // --- Catalogue (généré par scripts/generate-permissions.mjs — NE PAS ÉDITER) ---
  AbsencesCreate = "app.absences.create",
  AbsencesDelete = "app.absences.delete",
  AbsencesList = "app.absences.list",
  AbsencesUpdate = "app.absences.update",
  AccountingExportsGenerate = "app.accounting_exports.generate",
  ActivityHistoriesCreate = "app.activity_histories.create",
  ActivityHistoriesDelete = "app.activity_histories.delete",
  ActivityHistoriesList = "app.activity_histories.list",
  ActivityHistoriesUpdate = "app.activity_histories.update",
  ActivityLogsList = "app.activity_logs.list",
  BalancesCreate = "app.balances.create",
  BalancesDelete = "app.balances.delete",
  BalancesList = "app.balances.list",
  BalancesMovementsCreate = "app.balances.movements.create",
  BalancesMovementsDelete = "app.balances.movements.delete",
  BalancesMovementsList = "app.balances.movements.list",
  BalancesMovementsUpdate = "app.balances.movements.update",
  BalancesUpdate = "app.balances.update",
  BalancesView = "app.balances.view",
  BillingEntitiesCreate = "app.billing_entities.create",
  BillingEntitiesDelete = "app.billing_entities.delete",
  BillingEntitiesList = "app.billing_entities.list",
  BillingEntitiesUpdate = "app.billing_entities.update",
  BillingReferentialsCreate = "app.billing_referentials.create",
  BillingReferentialsDelete = "app.billing_referentials.delete",
  BillingReferentialsList = "app.billing_referentials.list",
  BillingReferentialsUpdate = "app.billing_referentials.update",
  CandidaciesCreate = "app.candidacies.create",
  CandidaciesDelete = "app.candidacies.delete",
  CandidaciesList = "app.candidacies.list",
  CandidaciesUpdate = "app.candidacies.update",
  CandidaciesView = "app.candidacies.view",
  CashregistersCreate = "app.cashregisters.create",
  CashregistersDelete = "app.cashregisters.delete",
  CashregistersList = "app.cashregisters.list",
  CashregistersUpdate = "app.cashregisters.update",
  CashregistersView = "app.cashregisters.view",
  CitiesActivate = "app.cities.activate",
  CitiesCreate = "app.cities.create",
  CitiesDelete = "app.cities.delete",
  CitiesList = "app.cities.list",
  CitiesManageInvoicingPeriods = "app.cities.manage_invoicing_periods",
  CitiesUpdate = "app.cities.update",
  CitiesView = "app.cities.view",
  CityAssignmentsList = "app.city_assignments.list",
  CityAssignmentsUpdate = "app.city_assignments.update",
  CommentsCreate = "app.comments.create",
  CommentsDelete = "app.comments.delete",
  CommentsList = "app.comments.list",
  CommentsUpdate = "app.comments.update",
  CompaniesCreate = "app.companies.create",
  CompaniesDelete = "app.companies.delete",
  CompaniesList = "app.companies.list",
  CompaniesUpdate = "app.companies.update",
  CompaniesView = "app.companies.view",
  ContactsCreate = "app.contacts.create",
  ContactsDelete = "app.contacts.delete",
  ContactsList = "app.contacts.list",
  ContactsUpdate = "app.contacts.update",
  DeduplicationCompaniesHistoryCancel = "app.deduplications.companies.history.cancel",
  DeduplicationCompaniesHistoryList = "app.deduplications.companies.history.list",
  DeduplicationCompaniesHistoryValidate = "app.deduplications.companies.history.validate",
  DeduplicationCompaniesList = "app.deduplications.companies.list",
  DeduplicationCompaniesMerge = "app.deduplications.companies.merge",
  DeduplicationMerchantsHistoryCancel = "app.deduplications.merchants.history.cancel",
  DeduplicationMerchantsHistoryList = "app.deduplications.merchants.history.list",
  DeduplicationMerchantsHistoryValidate = "app.deduplications.merchants.history.validate",
  DeduplicationMerchantsList = "app.deduplications.merchants.list",
  DeduplicationMerchantsMerge = "app.deduplications.merchants.merge",
  DepositsCreate = "app.deposits.create",
  DepositsDelete = "app.deposits.delete",
  DepositsList = "app.deposits.list",
  DepositsUpdate = "app.deposits.update",
  DepositsValidate = "app.deposits.validate",
  DepositsView = "app.deposits.view",
  DocumentRequirementsCreate = "app.document_requirements.create",
  DocumentRequirementsDelete = "app.document_requirements.delete",
  DocumentRequirementsList = "app.document_requirements.list",
  DocumentRequirementsUpdate = "app.document_requirements.update",
  DocumentsArchive = "app.documents.archive",
  DocumentsCreate = "app.documents.create",
  DocumentsDelete = "app.documents.delete",
  DocumentsList = "app.documents.list",
  DocumentsUpdate = "app.documents.update",
  EquipmentTypesCreate = "app.equipment_types.create",
  EquipmentTypesDelete = "app.equipment_types.delete",
  EquipmentTypesList = "app.equipment_types.list",
  EquipmentTypesUpdate = "app.equipment_types.update",
  EquipmentTypesView = "app.equipment_types.view",
  EquipmentsCreate = "app.equipments.create",
  EquipmentsDelete = "app.equipments.delete",
  EquipmentsList = "app.equipments.list",
  EquipmentsQualify = "app.equipments.qualify",
  EquipmentsUpdate = "app.equipments.update",
  EquipmentsView = "app.equipments.view",
  EventsCreate = "app.events.create",
  EventsDelete = "app.events.delete",
  EventsList = "app.events.list",
  EventsUpdate = "app.events.update",
  EventsView = "app.events.view",
  FeedsCreate = "app.feeds.create",
  FeedsDelete = "app.feeds.delete",
  FeedsList = "app.feeds.list",
  FeedsUpdate = "app.feeds.update",
  InfractionsCreate = "app.infractions.create",
  InfractionsDelete = "app.infractions.delete",
  InfractionsList = "app.infractions.list",
  InfractionsUpdate = "app.infractions.update",
  IntegrationsCreate = "app.integrations.create",
  IntegrationsDelete = "app.integrations.delete",
  IntegrationsList = "app.integrations.list",
  IntegrationsUpdate = "app.integrations.update",
  InvoicesCreate = "app.invoices.create",
  InvoicesCreditsCreate = "app.invoices.credits.create",
  InvoicesDelete = "app.invoices.delete",
  InvoicesEmailFailuresList = "app.invoices.email_failures.list",
  InvoicesExport = "app.invoices.export",
  InvoicesList = "app.invoices.list",
  InvoicesStatsView = "app.invoices.stats.view",
  InvoicesUpdate = "app.invoices.update",
  InvoicesView = "app.invoices.view",
  InvoicesViewOwn = "app.invoices.view_own",
  LocationsCreate = "app.locations.create",
  LocationsDelete = "app.locations.delete",
  LocationsList = "app.locations.list",
  LocationsUpdate = "app.locations.update",
  LocationsView = "app.locations.view",
  MarketMakingsAssignPlacer = "app.market_makings.assign_placer",
  MarketMakingsCreate = "app.market_makings.create",
  MarketMakingsDelete = "app.market_makings.delete",
  MarketMakingsList = "app.market_makings.list",
  MarketMakingsUpdate = "app.market_makings.update",
  MarketMakingsUpdateStatus = "app.market_makings.update_status",
  MarketMakingsView = "app.market_makings.view",
  MarketOfferTypesCreate = "app.market_offer_types.create",
  MarketOfferTypesDelete = "app.market_offer_types.delete",
  MarketOfferTypesList = "app.market_offer_types.list",
  MarketOfferTypesUpdate = "app.market_offer_types.update",
  MarketOfferTypesView = "app.market_offer_types.view",
  MarketReportsCreate = "app.market_reports.create",
  MarketReportsDelete = "app.market_reports.delete",
  MarketReportsList = "app.market_reports.list",
  MarketReportsUpdate = "app.market_reports.update",
  MarketReportsView = "app.market_reports.view",
  MarketsActivate = "app.markets.activate",
  MarketsCreate = "app.markets.create",
  MarketsDelete = "app.markets.delete",
  MarketsList = "app.markets.list",
  MarketsManageInvoicingPeriods = "app.markets.manage_invoicing_periods",
  MarketsUpdate = "app.markets.update",
  MarketsView = "app.markets.view",
  MaterialsCreate = "app.materials.create",
  MaterialsDelete = "app.materials.delete",
  MaterialsList = "app.materials.list",
  MaterialsUpdate = "app.materials.update",
  MaterialsView = "app.materials.view",
  MediaTypesCreate = "app.media_types.create",
  MediaTypesDelete = "app.media_types.delete",
  MediaTypesList = "app.media_types.list",
  MediaTypesUpdate = "app.media_types.update",
  MerchantsCreate = "app.merchants.create",
  MerchantsDelete = "app.merchants.delete",
  MerchantsList = "app.merchants.list",
  MerchantsUpdate = "app.merchants.update",
  MerchantsView = "app.merchants.view",
  MobileMarketsAccessAll = "app.mobile.markets.access_all",
  NavigationCreate = "app.navigation.create",
  NavigationDelete = "app.navigation.delete",
  NavigationList = "app.navigation.list",
  NavigationUpdate = "app.navigation.update",
  PaymentsCreate = "app.payments.create",
  PaymentsDelete = "app.payments.delete",
  PaymentsList = "app.payments.list",
  PaymentsUpdate = "app.payments.update",
  PaymentsView = "app.payments.view",
  PaymentsViewOwn = "app.payments.view_own",
  PermissionGroupsCreate = "app.permission_groups.create",
  PermissionGroupsDelete = "app.permission_groups.delete",
  PermissionGroupsList = "app.permission_groups.list",
  PermissionGroupsUpdate = "app.permission_groups.update",
  PermissionGroupsView = "app.permission_groups.view",
  PermissionsCreate = "app.permissions.create",
  PermissionsDelete = "app.permissions.delete",
  PermissionsList = "app.permissions.list",
  PermissionsUpdate = "app.permissions.update",
  PermissionsView = "app.permissions.view",
  PlacersAnomaliesList = "app.placers.anomalies.list",
  PlacersCreate = "app.placers.create",
  PlacersDelete = "app.placers.delete",
  PlacersInvoicingCreate = "app.placers.invoicing.create",
  PlacersInvoicingDelete = "app.placers.invoicing.delete",
  PlacersInvoicingList = "app.placers.invoicing.list",
  PlacersInvoicingUpdate = "app.placers.invoicing.update",
  PlacersList = "app.placers.list",
  PlacersPlanningsCreate = "app.placers.plannings.create",
  PlacersPlanningsDelete = "app.placers.plannings.delete",
  PlacersPlanningsList = "app.placers.plannings.list",
  PlacersPlanningsUpdate = "app.placers.plannings.update",
  PlacersPresencesList = "app.placers.presences.list",
  PlacersUpdate = "app.placers.update",
  PlacersView = "app.placers.view",
  ProductsCreate = "app.products.create",
  ProductsDelete = "app.products.delete",
  ProductsList = "app.products.list",
  ProductsManagePrices = "app.products.manage_prices",
  ProductsUpdate = "app.products.update",
  ProductsView = "app.products.view",
  ReferentialsCreate = "app.referentials.create",
  ReferentialsDelete = "app.referentials.delete",
  ReferentialsList = "app.referentials.list",
  ReferentialsUpdate = "app.referentials.update",
  RenewalExceptionsCreate = "app.renewal_exceptions.create",
  RenewalExceptionsDelete = "app.renewal_exceptions.delete",
  RenewalExceptionsList = "app.renewal_exceptions.list",
  RenewalExceptionsUpdate = "app.renewal_exceptions.update",
  RenewalExceptionsView = "app.renewal_exceptions.view",
  RenewalsAccess = "app.renewals.access",
  RenewalsGenerate = "app.renewals.generate",
  ReportTemplatesCreate = "app.report_templates.create",
  ReportTemplatesDelete = "app.report_templates.delete",
  ReportTemplatesList = "app.report_templates.list",
  ReportTemplatesUpdate = "app.report_templates.update",
  ReportingGenerate = "app.reporting.generate",
  RolesAssign = "app.roles.assign",
  RolesCreate = "app.roles.create",
  RolesDelete = "app.roles.delete",
  RolesList = "app.roles.list",
  RolesUpdate = "app.roles.update",
  SettingsAccess = "app.settings.access",
  SettingsGeneralCreate = "app.settings.general.create",
  SettingsGeneralDelete = "app.settings.general.delete",
  SettingsGeneralList = "app.settings.general.list",
  SettingsGeneralUpdate = "app.settings.general.update",
  SettingsInvoicingCreate = "app.settings.invoicing.create",
  SettingsInvoicingDelete = "app.settings.invoicing.delete",
  SettingsInvoicingList = "app.settings.invoicing.list",
  SettingsInvoicingUpdate = "app.settings.invoicing.update",
  SettingsOthersCreate = "app.settings.others.create",
  SettingsOthersDelete = "app.settings.others.delete",
  SettingsOthersList = "app.settings.others.list",
  SettingsOthersUpdate = "app.settings.others.update",
  SpacesCityAccess = "app.spaces.city.access",
  SpacesPlacerAccess = "app.spaces.placer.access",
  SubscriptionOffersCreate = "app.subscription_offers.create",
  SubscriptionOffersDelete = "app.subscription_offers.delete",
  SubscriptionOffersList = "app.subscription_offers.list",
  SubscriptionOffersUpdate = "app.subscription_offers.update",
  SubscriptionOffersView = "app.subscription_offers.view",
  SubscriptionsCreate = "app.subscriptions.create",
  SubscriptionsDelete = "app.subscriptions.delete",
  SubscriptionsList = "app.subscriptions.list",
  SubscriptionsUpdate = "app.subscriptions.update",
  SubscriptionsUpdateStatus = "app.subscriptions.update_status",
  SubscriptionsView = "app.subscriptions.view",
  UsersCreate = "app.users.create",
  UsersDelete = "app.users.delete",
  UsersDeleteOwn = "app.users.delete_own",
  UsersList = "app.users.list",
  UsersUpdate = "app.users.update",
  UsersView = "app.users.view",
  BoDomainsCreate = "bo.domains.create",
  BoDomainsDelete = "bo.domains.delete",
  BoDomainsList = "bo.domains.list",
  BoDomainsUpdate = "bo.domains.update",
  BoTenantsCreate = "bo.tenants.create",
  BoTenantsDelete = "bo.tenants.delete",
  BoTenantsList = "bo.tenants.list",
  BoTenantsUpdate = "bo.tenants.update",
  BoTenantsView = "bo.tenants.view",
  // --- Fin du catalogue généré ---
}
export default Permissions;
